// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q_Ic3GNwH2WG3up06KeI {
  position: relative;
  width: 476px;
  margin: auto auto;
}

.VCHxdnVMR9XWhuJzydhy {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  row-gap: 28px;
  padding: 0px 14px 28px 4px;
}
.VCHxdnVMR9XWhuJzydhy .uReXJI0dXIzX190eggiZ {
  position: absolute;
  top: 22px;
  left: 40px;
  font-size: 24px !important;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: 48px;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF .xNesecU9RjQ5TvF9LSyg {
  font-size: 16px !important;
  font-weight: 600;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF .xNesecU9RjQ5TvF9LSyg a {
  color: #774dee;
  text-decoration: none;
  font-size: 16px !important;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF .Y0zw8xOFG6zPfxx_zNR9 {
  color: #dbdbdb;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF .Y0zw8xOFG6zPfxx_zNR9 * {
  font-size: 14px;
  font-weight: 500;
}
.VCHxdnVMR9XWhuJzydhy .GwiR6BTbNI7yoSjeMDMF .Y0zw8xOFG6zPfxx_zNR9 a {
  color: #774dee;
  text-decoration: none;
}
.VCHxdnVMR9XWhuJzydhy .KVTHZGzfoX8rV0XXxRPj {
  cursor: pointer;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: filter 0.2s, transform 0.2s, box-shadow 0.2s;
}
.VCHxdnVMR9XWhuJzydhy .KVTHZGzfoX8rV0XXxRPj:hover {
  filter: brightness(85%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.VCHxdnVMR9XWhuJzydhy .KVTHZGzfoX8rV0XXxRPj:focus {
  outline: none;
}
.VCHxdnVMR9XWhuJzydhy .KVTHZGzfoX8rV0XXxRPj:active {
  filter: brightness(70%);
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/shared/auth/components/SignInModal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;AAAF;AAEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AADJ;AAGI;EACE,0BAAA;EACA,gBAAA;AADN;AAGM;EACE,cC9BC;ED+BD,qBAAA;EACA,0BAAA;AADR;AAKI;EACE,cChBU;ADahB;AAKM;EACE,eAAA;EACA,gBAAA;AAHR;AAMM;EACE,cC7CC;ED8CD,qBAAA;AAJR;AASE;EACE,eAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,wDACE;AARN;AAYI;EACE,uBAAA;EACA,wCAAA;AAVN;AAaI;EACE,aAAA;AAXN;AAcI;EACE,uBAAA;EACA,gBAAA;AAZN","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `q_Ic3GNwH2WG3up06KeI`,
	"contentWrapper": `VCHxdnVMR9XWhuJzydhy`,
	"title": `uReXJI0dXIzX190eggiZ`,
	"content": `GwiR6BTbNI7yoSjeMDMF`,
	"p1": `xNesecU9RjQ5TvF9LSyg`,
	"p2": `Y0zw8xOFG6zPfxx_zNR9`,
	"signInButton": `KVTHZGzfoX8rV0XXxRPj`
};
export default ___CSS_LOADER_EXPORT___;
